import React from 'react';
import '../styles/app-theme.css';

const slogans = [
  "Re-Think. Re-Use. Re-Word!",
  "Every Letter Counts, Every Play Matters!",
  "Find Words, Stack Scores, Win Big!",
  "Smart Plays. Big Scores. Re-Word!",
  "A Game of Words and Strategy!",
  "Use. Reuse. Dominate!",
  "Think Twice, Score Big!",
  "More Than Just Words—It's Strategy!",
  "Rearrange, Reuse, Rule!",
  "Multiply Your Words, Maximize Your Score!"
];

const getRandomSlogan = () => {
  const index = Math.floor(Math.random() * slogans.length);
  return slogans[index];
};

const GameHeader: React.FC = () => {
  const title = 'Re-Word Game';
  const slogan = getRandomSlogan();

  return (
    <div>
      <div style={{ textAlign: 'center', padding: '1rem 0' }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {title.split('').map((char, index) => (
            <span
              key={index}
              className='logo'
              style={{
                display: 'inline-block',
                transform: `rotate(${index % 2 === 0 ? 10 : -10}deg)`,
                fontSize: '2rem',
                fontWeight: 'bold',
                color: 'var(--text-header)',
                margin: '0 2px'
              }}
            >
              {char}
            </span>
          ))}
        </div>
        <div
          className='slogan'
          style={{
            marginTop: '0.5rem',
            color: 'var(--text-slogan)',
            opacity: 0.8
          }}
        >
          {slogan}
        </div>
      </div>
      
      <div
        style={{
          borderTop: '1px solid var(--info-bar)',
          marginBottom: '0.5rem',
          width: '100%',
        }}
      ></div>
    </div>
  );
};

export default GameHeader;
